import { ParcelDto, ServiceDto } from '@shared/types/parcel';

export interface SortingCenterParcelGetResponse {
  items: ParcelDto[];
}

/** Назначение фото посылки; значения — как в SortingCenter.Shared.Enum.ParcelPhotoType на бэкенде. */
export enum ParcelPhotoType {
  /** Фото при приёмке (DWS или камера ручной приёмки). */
  Acceptance = 0,
  /** Фото вложения при отмене: запрещённое или опасное содержимое. */
  Cancellation = 1,
}

export interface ParcelPhotoDto {
  id: string;
  photoType: ParcelPhotoType;
  /** Presigned-ссылка на файл, живёт ограниченное время; null — хранилище на бэкенде не настроено. */
  url: string | null;
  fileSize: number;
  /** Момент съёмки (ISO datetime, UTC). */
  createdAt: string;
}

export interface GetParcelPhotosResponse {
  photos: ParcelPhotoDto[];
}

export interface CancelParcelWithPhotoResponse {
  photoId: string;
  /** false — у посылки уже было фото отмены, Media оставил прежнее. */
  isPhotoNew: boolean;
  /** false — посылка уже была отменена раньше, события отмены повторно не ставились. */
  isCanceledNow: boolean;
}

export interface StatusCancel {
  id: CancellationReasonType;
  label: string;
}
export enum CancellationReasonType {
  Lost = 1,

  //Не востребован на точке выдаче
  NotPickedUpAtPickupPoint = 2,

  //Содержит запрещенный груз
  ContainsProhibitedItem = 3,

  //Недоставлен селлером
  UndeliveredBySeller = 4,

  //Отказ маркетплейса (озон глобал)
  MarketplaceCancellation = 5,

  //Отказ покупателя
  BuyerRejection = 6,

  //Последняя миля не везет
  LastMileNotApproved = 7,

  //Отказ селлера
  SellerRejection = 8,

  //Превышен габарит
  Oversized = 9,

  //Запрещен таможней
  ProhibitedByCustoms = 10,

  //Запрещен таможней
  Reexport = 11,

  //Не выпущено таможней по причине не верно предоставленных паспортных данных
  ProhibitedByCustomsIncorrectPassportData = 12,

  LostFistMile = 13,
  LostExportCustoms = 14,
  LostImportCustoms = 15,
  LostLastMileMile = 16,

  //Перевес
  OverWeight = 23,

  //Опасные материалы
  HazardMaterials = 29,

  //Опасный груз
  DangerousGoods = 41,
}

export interface CancelParcelDto {
  id: string;
  reason: CancellationReasonType;
  message: string;
}
